module.exports = __webpack_public_path__ + "static/img/bg-es.60d4b4d5.webp";